<div class="row">
  <div class="column small-12 small-3 large-3">
    <a [routerLink]="['/']">
      <img [src]="appCfg.conf.ui.logoImage"
           class="index-logo">
    </a>
  </div>
  <div class="column small-12 small-9 large-9">
  </div>
</div>
<div class="row">
  <div class="column small-12 small-12 large-12">
    <div class="row">
      <div class="column small-12 small-12 large-12">
        <div class="row cyc-overlay">
          <div class="column small-12 small-5 large-5 cyc-left-container">
            <div class="column small-12 small-12 large-12">
              <a class="return-btn" [routerLink]="['/']">
                <img src="./assets/img/arrow-left.svg"> {{'RETURN' | translate}} </a>
              <div class="cyc-first-txt">
                {{'YOU_ARE_ON_X' | translate | sprintf:clubName}}
              </div>
              <div class="cyc-city-txt">
                {{ 'LOCATED_AT_X' | translate | sprintf:(club.city | uppercase) }}
              </div>
              <div class="cyc-arrow"></div>
              <div class="cyc-last-txt">
                {{ '10123' | translate}} <!--Did you subscribed to another center?-->
                <br>
                {{ '10122' | translate }} <!--Please select your center before logging in-->
              </div>
            </div>
          </div>
          <div class="column small-12 small-6 large-6">
            <div class="cyc">
              <div class="row  small-collapse small-collapse large-collapse">
                <div class="column small-12">
                  <div class="cyc-form-filter">
                    <a [ngClass]="{'active': currentFilter === FILTERS.ALL }"
                       (click)="setFilter(FILTERS.ALL)">{{'ALL__FILTERS' | translate}}</a>
                    <a [ngClass]="{'active': currentFilter === FILTERS.CITY }"
                       (click)="setFilter(FILTERS.CITY)">{{'CITY' | translate}}</a>
                    <a [ngClass]="{'active': currentFilter === FILTERS.POSTAL_CODE }"
                       (click)="setFilter(FILTERS.POSTAL_CODE)">{{'POSTAL_CODE' | translate}}</a>
                    <a [ngClass]="{'active': currentFilter === FILTERS.CLUB_CODE }"
                       (click)="setFilter(FILTERS.CLUB_CODE)">{{'CENTER_CODE' | translate}}</a>
                  </div>
                </div>

                <div class="column small-12 small-12 large-12 cyc-form-container">
                  <div class="cyc-form-overlay">
                    <form class="cyc-form"
                          #form (submit)="handleSubmit($event, input.value)">
                      <input type="text" class="cyc-form-input"
                             [readonly]="isMobile"
                             [bvKeyboard]="{
                              onAccept: handleMockPaymentChange()
                             }"
                             [placeholder]="placeholder"
                             #input>
                    </form>
                  </div>
                </div>
                <div class="column small-12 small-12 large-12 cyc-ul-container">
                  <ul class="cyc-ul">
                    <li class="cyc-li"
                        *ngFor="let club of clubs$ | async" (click)="selectClub(club)">
                      <div class="cyc-li-content-container">
                        <div class="cyc-li-title">{{club.company}}</div>
                        <div class="cyc-li-txt"> {{club.postalCode}} {{club.city}} &mdash; <span>{{'CENTER' | translate}}: {{club.obId}}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
